@if (data.length === 0) {
  <div>
    {{'COMPONENTS.DELIVERY-METHOD-GRID.TITLE.EVENT-NOT-CREATED' | translate}}
  </div>
}

@if (!isInitialized && data.length !== 0) {
  <div>
    {{'COMPONENTS.DELIVERY-METHOD-GRID.LOADINGTEXT' | translate}}
  </div>
}

@if (tenantShopList != null && tenantShopList.length > 1 && isInitialized && data.length > 0) {
  <div class="mb-2">
    @for (tenantShop of tenantShopList; track tenantShop) {
      <div class="d-flex d-inline-flex p-0 m-1" (click)="setActive(tenantShop.Id)">
        <button class="m-0 btn btn-small" [class.btn-primary]="activeTenantShop.Id == tenantShop.Id">{{tenantShop.Name}}</button>
      </div>
    }
  </div>
}

@if (isInitialized && data.length > 0) {
  <div class="delivery-method-grid">
    @for (colLabel of columnLabels; track colLabel) {
      <div [ngStyle]="{'grid-column': colLabel.position, 'grid-row': 1}" class="grid-cell grid-cell--center grid-cell--label delivery-method-header">
        {{colLabel.name}}
      </div>
      @if (colLabel.position%2) {
        <div [ngStyle]="{'grid-row-end':numberOfRows, 'grid-column': colLabel.position}" class="column--borders"></div>
      }
    }
    @for (rowLabel of pageRowLabels; track rowLabel) {
      <div [ngStyle]="{'grid-column': 1, 'grid-row': rowLabel.position}" class="grid-cell grid-cell--label">
        {{rowLabel.name}}
      </div>
      @if (rowLabel.position%2) {
        <div [ngStyle]="{'grid-column-end':numberOfColumns, 'grid-row':rowLabel.position}" class="row--alternating"></div>
      }
    }
    @for (d of pageData; track d) {
      <div [ngStyle]="{'grid-column': getColumn(d), 'grid-row': getRow(d)}" class="grid-cell grid-cell--center">
        @if (useCustomStyledCheckboxes) {
          <div class="tri-state-inheritance" [ngClass]="getState(d)" (click)="updateValue(d)"></div>
        }
        @if (!useCustomStyledCheckboxes) {
          <input type="checkbox" readonly [checked]="getShownValue(d)" [indeterminate]="isIndeterminate(d)" (click)="updateValue(d)">
        }
      </div>
    }
  </div>
}

<div class="mt-3">
  <t4-pager-irregular-size (onPage)="updatePage($any($event).pageNr)" #pagerComponent></t4-pager-irregular-size>
</div>
